<template>
  <b-card>
    <b-form>
      <b-container>
        <b-row>
          <b-col
            md="3"
          >
            <div>

              <label for="resourceType">Resource Types</label>
              <v-select
                id="resourceType"
                v-model="queryParams.resourceType"
                placeholder="Select resource type"
                :options="resourceTypeOptions"
                :reduce="(option) => option.key"
                :clearable="false"
                @input="show"
              />
            </div>
          </b-col>
          <b-col
            md="3"
          >
            <div v-if="showZoneService">

              <label for="zones">Zones</label>
              <v-select
                id="zones"
                v-model="currZone"
                placeholder="Select zone"
                :options="zonesOptions"
                label="name"
                :clearable="false"
                :loading="zonesLoading"
                @input="setServices"
              />
            </div>
          </b-col>
          <b-col
            md="3"
          >
            <div v-if="showZoneService">

              <label for="services">Services</label>
              <v-select
                id="services"
                v-model="currService"
                :disabled="!currZone"
                :options="servicesOptions"
                placeholder="Select service"
                :clearable="false"
              />
            </div>
          </b-col>
          <b-col
            md="3"
            class="mt-2"
          >
            <b-button
              v-if="currService"
              variant="success"
              block
              :disabled="loading"
              @click="fetchLogs"
            >
              <b-spinner
                v-if="loading"
                small
              />
              <span v-else>Fetch</span>
            </b-button>
          </b-col>
        </b-row>
        <template v-if="logs.length">
          <b-table
            :fields="tableColumns"
            :items="logs"
            class="mt-2 text-center"
            striped
            responsive
            bordered
          >
            <template
              #cell(logsCheck)="row"
            >
              <b-form-checkbox
                v-model="row.detailsShowing"
                @change="row.toggleDetails"
              >
                <span>{{ row.detailsShowing ? 'Hide' : 'Show' }} Logs</span>
              </b-form-checkbox>

            </template>
            <template
              #row-details="row"
            >
              <b-table
                :items="row.item.difference"
                :fields="nestedFields"
                bordered
                striped
              />
            </template>
          </b-table>
        </template>
        <base-pagination
          v-show="logs.length"
          v-model="queryParams.page"
          :total="totalLogs"
          @new-per-page="queryParams.size = $event"
        />
      </b-container>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BContainer, BRow, BCol, BButton, BSpinner, BTable, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useLogs from '../hooks/useLogs'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import logsStore from '../store'
import BasePagination from '@/UI/BasePagination.vue'
import zonesStore from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BCard, BForm, BContainer, BRow, BCol, vSelect, BButton, BSpinner, BTable, BFormCheckbox, BasePagination,
  },

  setup(_, ctx) {
    useRegisterStoreModule('logs', logsStore)
    useRegisterStoreModule('zones', zonesStore)
    return {
      ...useLogs(ctx),
    }
  },

}
</script>

<style>

</style>
